<div class="p-4 mx-auto max-w-3xl md:p-6">
  <!-- Encabezado -->
  <div class="flex flex-col gap-4 mb-6 sm:flex-row sm:items-center sm:justify-between">
    <div>
      <h1 class="text-xl font-semibold text-gray-800 dark:text-white/90">Notificaciones</h1>
      <p class="mt-1 text-sm text-gray-500 dark:text-gray-400">
        {{ totalElements }} {{ totalElements === 1 ? 'notificación' : 'notificaciones' }} en total
      </p>
    </div>
    <button
      type="button"
      (click)="markAllAsRead()"
      class="inline-flex items-center justify-center px-4 py-2 text-sm font-medium text-white transition rounded-lg bg-brand-500 hover:bg-brand-600"
    >
      Marcar todas como leídas
    </button>
  </div>

  <!-- Filtros -->
  <div class="flex items-center gap-2 mb-4">
    <button
      type="button"
      (click)="toggleUnreadOnly(false)"
      class="px-3 py-1.5 text-sm font-medium rounded-lg transition border"
      [class.bg-brand-500]="!unreadOnly"
      [class.text-white]="!unreadOnly"
      [class.border-brand-500]="!unreadOnly"
      [class.bg-white]="unreadOnly"
      [class.text-gray-600]="unreadOnly"
      [class.border-gray-300]="unreadOnly"
      [class.dark:bg-gray-800]="unreadOnly"
      [class.dark:text-gray-300]="unreadOnly"
      [class.dark:border-gray-700]="unreadOnly"
    >
      Todas
    </button>
    <button
      type="button"
      (click)="toggleUnreadOnly(true)"
      class="px-3 py-1.5 text-sm font-medium rounded-lg transition border"
      [class.bg-brand-500]="unreadOnly"
      [class.text-white]="unreadOnly"
      [class.border-brand-500]="unreadOnly"
      [class.bg-white]="!unreadOnly"
      [class.text-gray-600]="!unreadOnly"
      [class.border-gray-300]="!unreadOnly"
      [class.dark:bg-gray-800]="!unreadOnly"
      [class.dark:text-gray-300]="!unreadOnly"
      [class.dark:border-gray-700]="!unreadOnly"
    >
      Solo no leídas
    </button>
  </div>

  <!-- Lista -->
  <div class="overflow-hidden bg-white border border-gray-200 rounded-2xl dark:border-gray-800 dark:bg-white/[0.03]">
    @if (loading) {
      <div class="flex items-center justify-center py-16 text-sm text-gray-500 dark:text-gray-400">
        Cargando notificaciones…
      </div>
    } @else if (loadError) {
      <div class="flex items-center justify-center py-16 text-sm text-error-500">
        No se pudieron cargar las notificaciones.
      </div>
    } @else if (notifications.length === 0) {
      <div class="flex flex-col items-center justify-center gap-2 py-16 text-center">
        <span class="flex items-center justify-center w-12 h-12 text-gray-400 bg-gray-100 rounded-full dark:bg-white/5">
          <svg width="24" height="24" viewBox="0 0 20 20" class="fill-current" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M10 4.29248C7.30765 4.29248 5.12504 6.47509 5.12504 9.16748V14.4591H14.875V9.16748C14.875 6.47509 12.6924 4.29248 10 4.29248ZM8.00004 17.7085C8.00004 18.1228 8.33583 18.4585 8.75004 18.4585H11.25C11.6643 18.4585 12 18.1228 12 17.7085H8.00004Z" fill="currentColor"/>
          </svg>
        </span>
        <span class="text-sm text-gray-500 dark:text-gray-400">No tienes notificaciones</span>
      </div>
    } @else {
      <ul class="divide-y divide-gray-100 dark:divide-gray-800">
        @for (n of notifications; track trackById($index, n)) {
          <li>
            <button
              type="button"
              (click)="onNotificationClick(n)"
              class="flex w-full gap-3 px-4 py-4 text-left transition hover:bg-gray-50 dark:hover:bg-white/[0.03]"
              [ngClass]="!n.isRead ? 'bg-brand-50 dark:bg-white/[0.04]' : ''"
            >
              <span class="mt-1.5 flex h-2.5 w-2.5 shrink-0 rounded-full"
                    [ngClass]="!n.isRead ? 'bg-brand-500' : 'bg-gray-300 dark:bg-gray-600'"></span>
              <span class="flex flex-col flex-1 min-w-0">
                <span class="text-sm"
                      [ngClass]="!n.isRead ? 'font-semibold text-gray-800 dark:text-white/90' : 'font-medium text-gray-600 dark:text-gray-300'">
                  {{ titulo(n) }}
                </span>
                @if (cuerpo(n); as detalle) {
                  <span class="mt-0.5 text-sm text-gray-500 dark:text-gray-400">{{ detalle }}</span>
                }
                <span class="mt-1 text-xs text-gray-400 dark:text-gray-500" [title]="formatFull(n.createdAt)">
                  {{ formatRelative(n.createdAt) }}
                </span>
              </span>
            </button>
          </li>
        }
      </ul>
    }
  </div>

  <!-- Paginación -->
  @if (!loading && !loadError && totalPages > 1) {
    <div class="flex items-center justify-between mt-4">
      <button
        type="button"
        (click)="prevPage()"
        [disabled]="!hasPrevious"
        class="px-4 py-2 text-sm font-medium text-gray-700 transition bg-white border border-gray-300 rounded-lg hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed dark:border-gray-700 dark:bg-gray-800 dark:text-gray-300 dark:hover:bg-gray-700"
      >
        Anterior
      </button>
      <span class="text-sm text-gray-500 dark:text-gray-400">
        Página {{ page + 1 }} de {{ totalPages }}
      </span>
      <button
        type="button"
        (click)="nextPage()"
        [disabled]="!hasNext"
        class="px-4 py-2 text-sm font-medium text-gray-700 transition bg-white border border-gray-300 rounded-lg hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed dark:border-gray-700 dark:bg-gray-800 dark:text-gray-300 dark:hover:bg-gray-700"
      >
        Siguiente
      </button>
    </div>
  }
</div>
